export const ZERO_WIDTH_CHAR = "\u200B";
